import { BASE_URL } from './constants';

export function generateGuestLink(id: string) {
  return `${BASE_URL}/request/${id}`;
}
